import { Button, useNotify, useRefresh } from "react-admin";
import { Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { erasmusRequests } from "api/erasmusApi";

const DeleteCoordinatorDialog = ({ id, name, label = "Изтрий" }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleDelete = async () => {
    await dataProvider.customRequest(erasmusRequests.deleteCoordinator(id), null, "DELETE");
    notify("Успешно изтрихте координатора", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      onConfirm={handleDelete}
      titleContent="Изтриване на координатор"
      saveTitle="Изтрий"
      closeTitle="Отказ"
      triggerButton={
        <Button
          label={label}
          startIcon={<DeleteIcon />}
          color="error"
        />
      }
    >
      <Typography
        color="error"
        sx={{ p: 2 }}
      >
        Сигурни ли сте, че искате да изтриете координатор {name}?
      </Typography>
    </ConfirmModal>
  );
};

export default DeleteCoordinatorDialog;
